module.exports = global["Application"] = require("-!/workspace/modules/web/idam-react/node_modules/babel-loader/lib/index.js!./main.js");